import { render } from "./FormularioContacto.vue?vue&type=template&id=0fb79365&scoped=true"
import script from "./FormularioContacto.vue?vue&type=script&lang=js"
export * from "./FormularioContacto.vue?vue&type=script&lang=js"

import "./FormularioContacto.vue?vue&type=style&index=0&id=0fb79365&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb79365"]])

export default __exports__